const DATE_FORMATTING_STRINGS = {
  dayOfWeek: 'iii, MMM d',
  dayOfYear: 'MMM d, yyyy',
  monthOfYear: 'MMM yyyy',
};

export default DATE_FORMATTING_STRINGS;
